<template>
  <li class="programCard" id="box">
    <div class="card-container">
      <router-link to="/download.html" target="_blank">
        <img :src="project.ImageUrl" class="cardBg">
      </router-link>
      <div class="cardContent">
        <div class="cardBox">
          <router-link :to="'/detail/'+project.ID" class="title" target="_blank" v-bind:title="project.Title">{{project.Title}}</router-link>
          <router-link :to="'/project/'+project.ID" class="desc" target="_blank">
            <span v-html="project.About"></span>
          </router-link>
          <div class="detail">
            <div>
              <img :src="project.PromoterPhoto? project.PromoterPhoto:'https://www.asstar.com/images/head-icon.png' " class="avatar fl">
              <span class="author">{{project.Promoter}}</span>
            </div>
            <span class="locate">{{project.Address}}</span>
            <span class="tag">{{getCategory(project.Category)}}</span>
          </div>
          <div class="progressContainer">
            <progress :value="parseInt(project.Progress*100)" max="100"></progress>
          </div>
          <nav>
            <p>
              <span title="指对项目存有意向且支付过预约金的用户总人次（包含退款人次记录）">认筹</span>
              <span class="num">{{project.CrowdQuantity}}</span>
              <span>人</span>
            </p>
            <p>
              <span title="参与人数*所支持档位全款（包含退款中金额）">认筹</span>
              <span class="num">{{project.CrowdAmount}}</span>
              <span>元</span>
            </p>
            <p>
              <span title="支持金额/目标金额">进度</span>
              <span class="num">{{parseInt(project.Progress*100)}}</span>
              <span>%</span>
            </p>
          </nav>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: "box",
  //data:{},
  props: ["project", "categoryData"],
  methods: {
    getCategory: function(id) {
      if (!this.categoryData || this.categoryData.length == 0) return "";
      var result = this.categoryData.find((item, index) => {
        if (item.Value == id) return item;
      });
      return result.DisplayName;
      return "";
    }
  },
  mounted() {

  }
};
</script>
